import { Descriptions, Form, InputNumber, Typography, theme } from "antd";
import React from "react";
import { FormItemHiddenUi } from "../../../ui/FormItemHiddenUi";
const { Text } = Typography;
export const SummaryOrder = ({ detallecomprobante }) => {
  const form = Form.useFormInstance();
  const moneda_prefijo = Form.useWatch("moneda_prefijo", form);
  const { token } = theme.useToken();
  const labelStyle = {
    width: "50%",
    fontWeight: "bold",
    justifyContent: "right",
    alignItems: "center",
  };
  const inputStyle = {
    fontSize: 18,
    color: token.colorPrimary,
    fontWeight: "bold",
  };
  return (
    <>
      <FormItemHiddenUi name="montototalgravadas" />
      <FormItemHiddenUi name="montototalexoneradas" />
      <FormItemHiddenUi name="montototalinafectas" />
      <FormItemHiddenUi name="montoigvtotal" />
      <FormItemHiddenUi name="montosubtotal" />
      <Descriptions size="small" column={1} className="summary_order">
        <Descriptions.Item>
          <Text type="secondary">
            {(detallecomprobante?.length || 0) + " productos"}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Total" labelStyle={labelStyle}>
          <Form.Item name="montototal" style={{ marginBottom: 0 }}>
            <InputNumber
              variant="borderless"
              readOnly={true}
              prefix={moneda_prefijo || "S/"}
              style={inputStyle}
              precision={2}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Descuento" labelStyle={labelStyle}>
          <Form.Item name="montodescuento" style={{ marginBottom: 0 }}>
            <InputNumber
              variant="borderless"
              readOnly={true}
              prefix={moneda_prefijo || "S/"}
              style={inputStyle}
              precision={2}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Total a pagar" labelStyle={labelStyle}>
          <Form.Item name="montototalpagar" style={{ marginBottom: 0 }}>
            <InputNumber
              variant="borderless"
              readOnly={true}
              prefix={moneda_prefijo || "S/"}
              style={inputStyle}
              precision={2}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Monto ingresado" labelStyle={labelStyle}>
          <Form.Item name="montoingresado" style={{ marginBottom: 0 }}>
            <InputNumber
              variant="borderless"
              readOnly={true}
              prefix={moneda_prefijo || "S/"}
              style={inputStyle}
              precision={2}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Vuelto" labelStyle={labelStyle}>
          <Form.Item name="montovuelto" style={{ marginBottom: 0 }}>
            <InputNumber
              variant="borderless"
              readOnly={true}
              prefix={moneda_prefijo || "S/"}
              style={inputStyle}
              precision={2}
            />
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};
